import {
  BrandIconColor,
  Link,
  LinkTarget,
  LinkVariant
} from '@ampcore/adel-react'
import React, { useRef } from 'react'

import { useSyncHeights } from '../../hooks/useSyncHeights'
import { BrandIconCompound } from '../BrandIconCompound/BrandIconCompound'
import { CategoriesBlock } from './Categories.type'

export const CategoriesBlocks = (props: {
  blocks: CategoriesBlock[]
  columnCount: number
  testId?: string
}) => {
  const { blocks, columnCount, testId } = props
  const gridClassNames: string[] = []
  switch (columnCount) {
    case 2:
      gridClassNames.push('u-size1of1 u-lg-size1of2')
      break
    case 3:
      gridClassNames.push('u-size1of1 u-md-size1of3 u-lg-size1of3')
      break
    case 4:
      gridClassNames.push('u-size1of1 u-md-size1of2 u-lg-size1of4')
      break
    default:
      gridClassNames.push('u-sm-sizeFull')
      break
  }

  const headingRefs = useRef<Array<React.RefObject<HTMLDivElement>>>([])
  if (headingRefs.current.length !== blocks.length) {
    headingRefs.current = blocks.map(
      (_, i) => headingRefs.current[i] || React.createRef<HTMLDivElement>()
    )
  }

  useSyncHeights(headingRefs.current, [blocks])

  return (
    <div className="Categories-blocks Grid Grid--withGutter">
      {blocks.map((block, idx) => (
        <div
          className={`u-marginTop48 u-flex u-flexCol ${gridClassNames.join(
            ' '
          )}`}
          key={block.title ?? idx}
          data-testid={testId ? `${testId}-block` : undefined}
        >
          <div className="Categories-block Content">
            {block.iconsDropdown && (
              <BrandIconCompound
                icon={block.iconsDropdown}
                iconColor={block.iconsColor || BrandIconColor.DARK_MINT}
                iconBgColor={block.iconsBgColor}
                fill={block.fill || !block.iconsColor}
                stroke={!!block.stroke}
                testId={testId ? `${testId}-icon-${idx}` : undefined}
              />
            )}
            {block.image && !block.iconsDropdown && (
              <div
                className="Categories-cardImage u-bgSizeCover u-marginBottom20"
                style={{ backgroundImage: `url(${block.image})` }}
                data-testid={testId ? `${testId}-image-${idx}` : undefined}
              ></div>
            )}
            {block.eyebrow && (
              <div
                className="u-textEyebrow u-textBold u-marginBottom8"
                data-testid={testId ? `${testId}-eyebrow` : null}
                dangerouslySetInnerHTML={{ __html: block.eyebrow }}
              />
            )}
            <div
              className="Categories-heading u-marginBottom20"
              data-testid={testId ? `${testId}-category-container` : undefined}
              ref={headingRefs.current[idx]}
            >
              {block.url ? (
                <Link
                  url={block.url}
                  target={block.linkTarget as LinkTarget}
                  data-analytics={block.analytics}
                  name={block.title ?? ''}
                  variant={LinkVariant.UNSTYLED}
                  className="Type-4 u-textColorActionBlue u-block"
                  data-testid={testId ? `${testId}-title` : undefined}
                />
              ) : (
                <div
                  data-testid={testId ? `${testId}-title` : undefined}
                  className="Type-4 u-textBold"
                  dangerouslySetInnerHTML={{ __html: block.title ?? '' }}
                ></div>
              )}
            </div>
            <div className="Categories-content">
              {block.content && (
                <div dangerouslySetInnerHTML={{ __html: block.content }}></div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
